import intlTelInput from "intl-tel-input/intlTelInputWithUtils";

export default function formatPhone(elPhone: string = '.format-input-phone'){
        
    const items_input = document.querySelectorAll(elPhone);

    if(items_input === null){

        return null;

    }

    items_input.forEach((item) => {

        const input = item as HTMLInputElement;

        const phone_number = intlTelInput(input, {
            nationalMode: true,
            initialCountry: "it",
            countryOrder: ['it'],
            separateDialCode: true,
            hiddenInput: () => ({
                phone: "phone_full",
                country: "phone_country_code"
            }),
        });

        input.addEventListener("change", () => {

            const complete_phone = phone_number.getNumber();
            const phone_full = document.querySelector('input[name=phone_full]') as HTMLInputElement;
            phone_full.value = complete_phone;

            const countryData = phone_number.getSelectedCountryData();
            const phone_country_code = document.querySelector('input[name=phone_country_code]') as HTMLInputElement;

            if(typeof countryData.iso2 !== 'undefined'){
                
                phone_country_code.value = countryData.iso2;

            }
           
        });

        return phone_number;
        
    });
    
}